module.exports = "/images/arrow-back.svg";